import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import type { Params } from '@angular/router';
import { AppLinkService } from '../../../core/services';
import { SidebarService } from '../sidebar.service';
import { ShortcutsService } from './shortcuts.service';

/**
 * Collapsible SHORTCUTS strip under the sidebar search box: pinned pages first, then
 * recent pages. Hidden while searching and when both lists are empty.
 */
@Component({
    selector: 'app-sidebar-shortcuts',
    imports: [RouterLink],
    templateUrl: './sidebar-shortcuts.component.html',
    styleUrls: ['../sidebar-interaction.css']
})
export class SidebarShortcutsComponent {
    private appLinkService = inject(AppLinkService);
    private sidebarService = inject(SidebarService);

    shortcutsService = inject(ShortcutsService);

    isCollapsed = this.shortcutsService.isCollapsed;
    canPin = this.shortcutsService.canPin;

    isVisible = computed(() => this.shortcutsService.hasShortcuts() && !this.sidebarService.isSearching());

    /* Pinned rows first, then recents — one template loop renders both. */
    shortcutRows = computed(() => [...this.shortcutsService.pinnedItems().map((item) => ({ item, isPinned: true })), ...this.shortcutsService.recentItems().map((item) => ({ item, isPinned: false }))]);

    routerLinkQueryParams(): Params | null {
        return this.appLinkService.addImpersonationQueryParams();
    }

    onToggleCollapsed() {
        this.shortcutsService.toggleCollapsed();
    }

    onNavigate() {
        this.sidebarService.closeSidebar();
    }

    onTogglePinned(event: Event, routerLink: string | undefined) {
        // The pin button lives inside the navigation anchor — don't navigate.
        event.preventDefault();
        event.stopPropagation();

        if (routerLink) {
            this.shortcutsService.togglePinned(routerLink);
        }
    }
}
